import { render } from "./BankAccountCardContainer.vue?vue&type=template&id=189d5b5f"
import script from "./BankAccountCardContainer.vue?vue&type=script&lang=js"
export * from "./BankAccountCardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__